import React from 'react';
import {UserCardWrapper, UserImage, UserImageWrapper
} from "./user-card.styles";

const UserCard = ({name, type, status, image_source, descChildren, children}) => {

    return (
        <UserCardWrapper status={status}>
            <div className='d-flex flex-column flex-lg-row align-items-center'>
                <UserImageWrapper>
                    <UserImage>
                        <img src={image_source} alt='avatar'/>
                    </UserImage>
                </UserImageWrapper>
                <div className='text-center text-lg-end rtl mt-3 mt-lg-0 me-lg-4'>
                    <p className='dark-gray mb-1'>{name}</p>
                    <p className='gray-color fs-c-5 mb-4 mb-lg-0'>{type}</p>
                    {descChildren}
                </div>
            </div>
            {children}
        </UserCardWrapper>
    );
};

export default UserCard;
